// src/components/layout/UserNavigation.jsx
import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { User, LogOut, Settings } from 'lucide-react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { useAuth } from 'lib/auth';

export const UserNavigation = () => {
  const { user, logout } = useAuth();

  const items = [
    { name: 'Profile', to: '/app/profile', icon: <User size={16} /> },
    { name: 'Settings', to: '/app/settings', icon: <Settings size={16} /> },
    {
      name: 'Logout',
      icon: <LogOut size={16} />,
      onClick: logout,
      to: '',
    },
  ];

  return (
    <Menu as="div" className="relative">
      <Menu.Button className="flex items-center gap-2 px-2 py-1 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition">
        <div className="w-8 h-8 rounded-full bg-gray-300 dark:bg-gray-600 flex items-center justify-center">
          <User size={16} />
        </div>
        <span className="text-sm font-medium hidden md:inline">{user?.firstName || 'You'}</span>
      </Menu.Button>

      <Transition
        as={Fragment}
        enter="transition duration-100 ease-out"
        enterFrom="opacity-0 scale-95 translate-y-1"
        enterTo="opacity-100 scale-100 translate-y-0"
        leave="transition duration-75 ease-in"
        leaveFrom="opacity-100 scale-100 translate-y-0"
        leaveTo="opacity-0 scale-95 translate-y-1"
      >
        <Menu.Items className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-xl border dark:border-gray-700 overflow-hidden z-50">
          {items.map((item) => (
            <Menu.Item key={item.name}>
              {({ active }) => (
                <Link
                  onClick={item.onClick}
                  to={item.to}
                  className={clsx(
                    'flex items-center gap-2 px-4 py-2 text-sm',
                    active ? 'bg-gray-100 dark:bg-gray-700' : '',
                    'text-gray-800 dark:text-gray-300'
                  )}
                >
                  {item.icon}
                  {item.name}
                </Link>
              )}
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
};
